import { render, staticRenderFns } from "./CalendarMovementForm.vue?vue&type=template&id=44a0d1c9&"
import script from "./CalendarMovementForm.vue?vue&type=script&lang=js&"
export * from "./CalendarMovementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports